import { createContext, useRef, useState } from 'react';
import Audio from '../components/atomos/Audio';

export const AudiosLockerContext = createContext({
  handleAudioPlay: () => {}
});

export function AudiosLockerProvider({ children }) {
  const audioRef = useRef(null);
  const [audioReps, setAudioReps] = useState([]);

  const handleAudioPlay = (audioSrc, time = 8000) => {
    if (!audioReps.includes(audioSrc)) {
      setAudioReps((prevAudioReps) => [...prevAudioReps, audioSrc]);
      audioRef.current.src = audioSrc;
      audioRef.current.play();

      setTimeout(() => {
        setAudioReps((prevAudioReps) => prevAudioReps.filter((a) => a !== audioSrc));
      }, time);
    }
  };

  return (
    <AudiosLockerContext.Provider value={{ handleAudioPlay }}>
      {children}
      <Audio audioRef={audioRef} />
    </AudiosLockerContext.Provider>
  );
}
